module.exports = __webpack_public_path__ + "img/dinapsis-logo-background.4e00291a.svg";